import { NgModule } from '@angular/core';

import { ActCreationModule } from './act-creation/act-creation.module';
import { ActRequestMessageModule } from './act-request-message/act-request-message.module';
import { ParamterDocumentUploaderModule } from './parameter-document-uploader/parameter-document-uploader.module';
import { TemplateActCreationModule } from './template-act-creation/template-act-creation.module';
import { ActDocumentListModule } from './act-document-list/act-document-list.module';
import { ParameterActServiceListModule } from './parameter-act-service-list/parameter-act-service-list.module';
import { ParamterComponentListControlerModule } from './parameter-component-list-controler/parameter-component-list-controler.module';
import { ParameterDocumentLinkSelectorModule } from './parameter-document-link-selector/parameter-document-link-selector.module';
import { ParameterListModule } from './parameter-list/parameter-list.module';
import { ParameterStringModule } from './parameter-string/parameter-string.module';
import { ParameterSwitchModule } from './parameter-switch/parameter-switch.module';
import { ActReferenceListModule } from './act-reference-list/act-reference-list.module';

@NgModule({
  exports: [
    ActCreationModule,
    ActDocumentListModule,
    ActRequestMessageModule,
    ParameterActServiceListModule,
    ParamterComponentListControlerModule,
    ParameterDocumentLinkSelectorModule,
    ParamterDocumentUploaderModule,
    ParameterListModule,
    ParameterStringModule,
    ParameterSwitchModule,
    TemplateActCreationModule,
    ActReferenceListModule
  ]
})
export class ActsModules {}
